import { Record } from 'immutable';

const EventSearchFilterRecord = Record({
  filterField: null,
  filterValue: null
});

export class EventSearchFilter extends EventSearchFilterRecord {
  filterField: string;
  filterValue: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-filter.ts